"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Close_1 = __importDefault(require("@material-ui/icons/Close"));
const FilterList_1 = __importDefault(require("@material-ui/icons/FilterList"));
const react_1 = require("react");
const usehooks_ts_1 = require("usehooks-ts");
const Filter_1 = require("./Filter");
function FilterContainer({ header, table, resetFilter, }) {
    const modalRef = (0, react_1.useRef)(null);
    const [active, setActive] = (0, react_1.useState)(false);
    (0, usehooks_ts_1.useOnClickOutside)(modalRef, () => setActive(false));
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", { onClick: () => {
                    setActive(!active);
                    if (active) {
                        resetFilter();
                    }
                }, role: "button", tabIndex: 0, onKeyDown: (e) => {
                    if (e.key === 'Enter') {
                        setActive(!active);
                        if (active) {
                            resetFilter();
                        }
                    }
                }, "data-testid": "filter-button", children: (0, jsx_runtime_1.jsx)(FilterList_1.default, { fontSize: "small", className: `sort-or-filter-icon ${header.column.getIsFiltered() ? 'active' : ''}` }) }), active && ((0, jsx_runtime_1.jsxs)("div", { className: "filter-popover", ref: modalRef, children: [(0, jsx_runtime_1.jsx)(Filter_1.Filter, { column: header.column, table: table }), (0, jsx_runtime_1.jsx)(Close_1.default, { onClick: () => {
                            setActive(!active);
                        }, className: "filter-close", "aria-label": "Close Filter", fontSize: "small" })] }))] }));
}
exports.FilterContainer = FilterContainer;
